export default {
    SET_SERVICES(state, services) {
        state.services = services;
    },
    CREATE_SERVICE(state, service) {
        state.services.items.unshift(service);
    },
    UPDATE_SERVICE(state, service) {
        const serviceIndex = state.services.items.findIndex((s) => s.id === service.id)
        Object.assign(state.services.items[serviceIndex], service)
    },
    DELETE_SERVICE(state, id) {
        const index = state.services.items.findIndex((element) => element.id === id);
        state.services.items.splice(index, 1);
    }
}